export enum TimelineItemTypeType {
  'subject' = 'subject',
  'extra' = 'extra',
  'interval' = 'interval',
}

export type TimelineDraggableCollectedProps = {
  isDragging: boolean;
};

export type TimelineDragObject = {
  id: string;
  type: string;
  duration: number;
  title: string;
  color: string;
  itemType: TimelineItemTypeType;
  elementID?: string;
  lecturerID?: string;
  subjectName?: string;
};

export type TimetableCalendarItem = {
  id?: string | null;
  title?: string | null;
  subject?: string | null;
  start: Date;
  end: Date;
  batch?: string | null;
  location?: string | null;
  color?: string | null;
  class?: string;
  lecturer?: string;
};
